export const version = "contracts/5.2.0";
//# sourceMappingURL=_version.js.map